import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/navigation/Header';
import GlobalFilterBar from '../../components/navigation/GlobalFilterBar';
import ComplianceAlertBanner from '../../components/navigation/ComplianceAlertBanner';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import DashboardPreviewCard from './components/DashboardPreviewCard';
import AffiliatePromotionPanel from './components/AffiliatePromotionPanel';


import InteractiveDemoLauncher from './components/InteractiveDemoLauncher';
import { Play, Sparkles, CheckCircle, TrendingUp, Shield, Clock } from 'lucide-react';

const ProductDemoOnboardingHub = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState('all');
  const [selectedFunction, setSelectedFunction] = useState('all');
  const [showDemoLauncher, setShowDemoLauncher] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(null);

  // Add this block - Handler for GlobalFilterBar
  const handleFilterChange = (filters) => {








    // Filter changes handled by GlobalFilterBar component
  };const dashboards = [{ id: 'executive-board', name: 'Executive Board Dashboard', path: '/executive-board-dashboard', icon: 'TrendingUp', role: 'executive',
    function: 'analytics',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1891a8c3e-1768604060126.png",
    alt: "Papua New Guinean executive leader reviewing strategic analytics and compliance dashboards",
    features: [
    'Real-time compliance scoring across all departments',
    'Financial projections with PNG Kina currency formatting',
    'Strategic workforce planning with quarterly trends',
    'Executive alert panel for critical compliance issues'],

    description: 'Comprehensive executive overview with strategic insights and compliance monitoring for PNG Employment Act 1978 requirements.'
  },
  {
    id: 'compliance-overview',
    name: 'Compliance Overview',
    path: '/compliance-overview',
    icon: 'Shield',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_153c9d573-1768800730323.png",
    alt: "Pacific Islander HR manager reviewing PNG Employment Act compliance documents",
    features: [
    'Real-time compliance monitoring dashboard',
    'PNG Employment Act 1978 violation tracking',
    'Automated regulatory alerts and notifications',
    'Department-level compliance scoring'],

    description: 'Monitor compliance status across all PNG regulatory requirements with real-time alerts and automated tracking.'
  },
  {
    id: 'workforce-analytics',
    name: 'Workforce Analytics',
    path: '/workforce-analytics',
    icon: 'Users',
    role: 'manager',
    function: 'analytics',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_108a713df-1768430802925.png",
    alt: "Diverse Papua New Guinean government team collaborating on workforce analytics",
    features: [
    'Demographic breakdown with PNG citizenship tracking',
    'Employment type distribution analysis',
    'Workforce trends and forecasting',
    'Custom report generation and export'],

    description: 'Comprehensive workforce analytics with PNG-specific demographic insights and compliance metrics.'
  },
  {
    id: 'payroll-compliance',
    name: 'Payroll Compliance',
    path: '/payroll-compliance',
    icon: 'DollarSign',
    role: 'manager',
    function: 'payroll',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_174f7ac0b-1768604060071.png",
    alt: "Melanesian HR manager processing payroll calculations with PNG Kina currency",
    features: [
    'Automated PNG minimum wage compliance checks',
    'NASFUND and SWT filing automation',
    'Payroll variance analysis with Kina formatting',
    'Government lodgement tracking and confirmations'],

    description: 'Ensure payroll compliance with PNG regulations including NASFUND, SWT, and minimum wage requirements.'
  },
  {
    id: 'leave-management',
    name: 'Leave Tracking',
    path: '/leave-management',
    icon: 'Clock',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_16809a7e1-1768445734415.png",
    alt: "Pacific Islander manager reviewing employee leave schedules and PNG public holidays",
    features: [
    'PNG Employment Act leave entitlement tracking',
    'Automated leave balance calculations',
    'Policy violation detection and alerts',
    'Leave trend analysis and forecasting'],

    description: 'Manage leave entitlements in compliance with PNG Employment Act 1978 with automated tracking and alerts.'
  },
  {
    id: 'payroll-management',
    name: 'Payroll Management',
    path: '/payroll-management',
    icon: 'Wallet',
    role: 'manager',
    function: 'payroll',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6da866c-1768531199001.png",
    alt: "Papua New Guinean payroll officer processing NASFUND and SWT calculations",
    features: [
    'Bulk payroll processing with PNG Kina calculations',
    'Automated payslip generation and distribution',
    'Batch approval workflows',
    'Payroll schedule configuration'],

    description: 'Streamline payroll operations with automated processing, approval workflows, and PNG-compliant calculations.'
  },
  {
    id: 'team-access',
    name: 'Team Access Management',
    path: '/team-access-management',
    icon: 'Users',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1c30ee070-1768531200045.png",
    alt: "Melanesian team leader managing departmental access permissions and security",
    features: [
    'Role-based access control (RBAC)',
    'User activity monitoring and audit trails',
    'Department-level permission management',
    'Access statistics and compliance reporting'],

    description: 'Manage team access with role-based permissions and comprehensive activity monitoring.'
  },
  {
    id: 'approval-management',
    name: 'Approval Management',
    path: '/approval-management',
    icon: 'CheckSquare',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1d638fbb4-1770857696081.png",
    alt: "Pacific Islander department head reviewing and approving employee leave requests",
    features: [
    'Multi-level approval workflows',
    'Automated routing and escalation rules',
    'Delegation management',
    'Approval chain visualization'],

    description: 'Configure and manage approval workflows with automated routing, escalation, and delegation capabilities.'
  },
  {
    id: 'employee-self-service',
    name: 'Employee Self-Service Portal',
    path: '/employee-self-service-portal',
    icon: 'UserCheck',
    role: 'employee',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1960d979a-1768604060126.png",
    alt: "Papua New Guinean government employee accessing digital payslips and leave balances",
    features: [
    'Leave request submission and tracking',
    'Digital payslip access and download',
    'Personal records management',
    'Dashboard with leave balances and approvals'],

    description: 'Empower employees with self-service access to leave requests, payslips, and personal records.'
  },
  {
    id: 'user-analytics',
    name: 'User Analytics Dashboard',
    path: '/user-analytics-dashboard',
    icon: 'BarChart3',
    role: 'executive',
    function: 'analytics',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1929c1fa3-1768531198771.png",
    alt: "Melanesian executive analyzing user engagement metrics and system usage patterns",
    features: [
    'Feature usage tracking and heatmaps',
    'User engagement trend analysis',
    'Bottleneck identification',
    'Training recommendations based on usage patterns'],

    description: 'Track system usage patterns and identify opportunities for training and process improvement.'
  },
  {
    id: 'company-accounts',
    name: 'Company Accounts Management',
    path: '/company-accounts-management',
    icon: 'Building2',
    role: 'executive',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1c64acabf-1768531199754.png",
    alt: "Pacific Islander administrator managing multiple PNG government department accounts",
    features: [
    'Multi-company account management',
    'Compliance scoring across organizations',
    'Billing status and subscription tracking',
    'Quick actions for account administration'],

    description: 'Manage multiple company accounts with centralized compliance monitoring and billing oversight.'
  },
  {
    id: 'departmental-budget',
    name: 'Departmental Budget Management',
    path: '/departmental-budget-management',
    icon: 'Calculator',
    role: 'manager',
    function: 'payroll',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_174f7ac0b-1768604060071.png",
    alt: "Papua New Guinean finance manager analyzing departmental budget forecasts in PNG Kina",
    features: [
    'Department-level budget tracking with PNG Kina',
    'Payroll cost analysis and forecasting',
    'Compliance impact calculations',
    'Spending trend visualization'],

    description: 'Track and forecast departmental budgets with payroll cost analysis and compliance impact assessments.'
  },
  {
    id: 'strategic-calendar',
    name: 'Strategic Workforce Calendar',
    path: '/strategic-workforce-calendar',
    icon: 'CalendarDays',
    role: 'manager',
    function: 'analytics',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_16809a7e1-1768445734415.png",
    alt: "Melanesian department head planning workforce schedules with PNG public holiday calendar",
    features: [
    'Integrated leave, events, and deadline tracking',
    'Department availability visualization',
    'Resource conflict detection',
    'PNG public holiday integration'],

    description: 'Strategic workforce planning with integrated calendar showing leave, events, deadlines, and team availability.'
  },
  {
    id: 'audit-trail',
    name: 'Audit Trail',
    path: '/audit-trail',
    icon: 'FileText',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_153c9d573-1768800730323.png",
    alt: "Pacific Islander compliance officer reviewing comprehensive audit trail reports",
    features: [
    'Comprehensive system activity logging',
    'User action tracking and timestamps',
    'Audit report generation and export',
    'Advanced filtering and search capabilities'],

    description: 'Complete audit trail of all system activities with detailed logging and export capabilities.'
  },
  {
    id: 'custom-report-builder',
    name: 'Custom Compliance Report Builder',
    path: '/custom-compliance-report-builder',
    icon: 'FileText',
    role: 'manager',
    function: 'compliance',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_113b46d51-1770857695282.png",
    alt: "Papua New Guinean analyst building custom DLIR compliance reports for government filing",
    features: [
    'Drag-and-drop metric selection',
    'Department and date range filtering',
    'Multiple export formats (PDF, Excel, CSV)',
    'Template library for common reports'],

    description: 'Build custom compliance reports with flexible metric selection and multiple export options.'
  }];


  const filteredDashboards = dashboards?.filter((dashboard) => {
    const roleMatch = selectedRole === 'all' || dashboard?.role === selectedRole;
    const functionMatch = selectedFunction === 'all' || dashboard?.function === selectedFunction;
    return roleMatch && functionMatch;
  });

  const handleStartTrial = () => {
    navigate('/payment-contact');
  };

  const handleContactSales = () => {
    navigate('/payment-contact');
  };

  const handleLaunchDemo = () => {
    setShowDemoLauncher(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-amber-50">
      <Header />
      <GlobalFilterBar onFilterChange={handleFilterChange} />
      <ComplianceAlertBanner />
      {/* Hero Section with Enhanced Design */}
      <div className="relative overflow-hidden bg-gradient-to-r from-green-700 via-emerald-600 to-green-700 text-white">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6 border border-white/20">
              <Sparkles className="w-5 h-5 text-amber-300" />
              <span className="text-sm font-medium">Pacific RBS Ltd - HR Compliance Platform</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-white to-amber-100 bg-clip-text text-transparent">
              Welcome to Your Compliance Dashboard
            </h1>
            <p className="text-xl text-green-50 max-w-3xl mx-auto mb-8">
              Explore powerful features designed for PNG government departments and organizations
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button
                onClick={() => setShowDemoLauncher(true)}
                className="bg-amber-500 hover:bg-amber-600 text-gray-900 font-semibold px-8 py-3 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">

                <Play className="w-5 h-5 mr-2" />
                Launch Interactive Demo
              </Button>
              <Button
                onClick={() => navigate('/compliance-overview')}
                className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-semibold px-8 py-3 rounded-lg border-2 border-white/30 hover:border-white/50 transition-all duration-300">

                <Shield className="w-5 h-5 mr-2" />
                Go to Dashboard
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* Stats Section with Enhanced Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white rounded-2xl shadow-xl p-6 border-t-4 border-green-600 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 bg-gradient-to-br from-green-100 to-emerald-100 rounded-xl">
                <CheckCircle className="w-8 h-8 text-green-600" />
              </div>
              <span className="text-3xl font-bold text-green-600">15+</span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Dashboards</h3>
            <p className="text-gray-600 text-sm">Comprehensive views for every role</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 border-t-4 border-amber-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 bg-gradient-to-br from-amber-100 to-yellow-100 rounded-xl">
                <TrendingUp className="w-8 h-8 text-amber-600" />
              </div>
              <span className="text-3xl font-bold text-amber-600">100%</span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Compliance</h3>
            <p className="text-gray-600 text-sm">PNG Employment Act aligned</p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-6 border-t-4 border-emerald-600 hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex items-center justify-between mb-4">
              <div className="p-3 bg-gradient-to-br from-emerald-100 to-green-100 rounded-xl">
                <Clock className="w-8 h-8 text-emerald-600" />
              </div>
              <span className="text-3xl font-bold text-emerald-600">24/7</span>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Real-time</h3>
            <p className="text-gray-600 text-sm">Automated monitoring & alerts</p>
          </div>
        </div>
      </div>
      <main className="container mx-auto px-4 py-6 md:py-8">
        {/* Filters Section with Enhanced Design */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6 border border-green-100">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Sparkles className="w-5 h-5 text-amber-500" />
              Filter Dashboards
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Role</label>
                <select
                  value={selectedRole}
                  onChange={(e) => setSelectedRole(e?.target?.value)}
                  className="w-full px-4 py-2.5 border-2 border-green-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200">

                  <option value="all">All Roles</option>
                  <option value="executive">Executive</option>
                  <option value="manager">Manager</option>
                  <option value="employee">Employee</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Filter by Function</label>
                <select
                  value={selectedFunction}
                  onChange={(e) => setSelectedFunction(e?.target?.value)}
                  className="w-full px-4 py-2.5 border-2 border-green-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200">

                  <option value="all">All Functions</option>
                  <option value="compliance">Compliance</option>
                  <option value="analytics">Analytics</option>
                  <option value="payroll">Payroll</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content with Sidebar Layout */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Dashboard Grid - Main Content */}
            <div className="flex-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {filteredDashboards?.map((dashboard) =>
                <DashboardPreviewCard
                  key={dashboard?.id}
                  dashboard={dashboard}
                  onPlayVideo={(id) => setVideoPlaying(id)}
                  isPlaying={videoPlaying === dashboard?.id} />

                )}
              </div>

              {filteredDashboards?.length === 0 &&
              <div className="bg-card border border-border rounded-lg p-12 text-center">
                  <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-4" />
                  <h3 className="font-semibold text-lg text-foreground mb-2">No Dashboards Found</h3>
                  <p className="text-sm text-muted-foreground mb-4">Try adjusting your filters to see more results</p>
                  <Button variant="outline" onClick={() => {setSelectedRole('all');setSelectedFunction('all');}}>
                    Clear Filters
                  </Button>
                </div>
              }
            </div>

            {/* Sidebar - Affiliate Promotion */}
            <aside className="lg:w-80 flex-shrink-0">
              <AffiliatePromotionPanel />
            </aside>
          </div>
        </div>
      </main>
      {/* Interactive Demo Launcher Modal */}
      {showDemoLauncher &&
      <InteractiveDemoLauncher
        dashboards={dashboards}
        onClose={() => setShowDemoLauncher(false)} />

      }
    </div>);


};

export default ProductDemoOnboardingHub;